module.exports = __webpack_public_path__ + "1_0_65/img/time_task.cec658fe.svg";